@if (memberships.length === 0) {
<p class="text-xs text-gray-400 italic px-1">No members yet.</p>
} @else {
<div class="flex flex-col gap-1">
    @for (membership of memberships; track membership.id) {
    <app-group-member-item [membership]="membership" [isRemoving]="removingIds.has(membership.operatorId!)"
        (remove)="onRemove($event)">
    </app-group-member-item>
    }
</div>
}